// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"1b71f0bf","66":"20681dc9","164":"c9934709","362":"95d1063e","381":"d0f2ff34","604":"4f01fc3d","764":"6c445a12","837":"2d4e4ffa"}[chunkId] + ".css";
};